export default __webpack_public_path__ + "static/media/follow-bridge.4cd88faf.webp";